import { AutomobileModel } from './automobile-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class AutomobileYear extends AbstractModel {
  @autoserialize
  automobileMakeId: number;

  @autoserializeAs(AutomobileModel)
  automobileModel: AutomobileModel;

  @autoserialize
  year: string;
}
